export default class User {
  static fromDto(dto: JwtPayload): User {
    if (dto) {
      return new User(
        true,
        dto.sub,
        dto.email,
        (dto['cognito:groups'] || []).map((group: string) => UserGroup[group.toUpperCase() as keyof typeof UserGroup]),
      );
    } else {
      return User.anonymousUser();
    }
  }

  static anonymousUser(): User {
    return new User(false, null, null, []);
  }

  constructor(
    public authenticated: boolean,
    public id: string | null,
    public email: string | null,
    public groups: UserGroup[],
  ) {}

  isAdmin(): boolean {
    return this.groups.includes(UserGroup.ADMIN);
  }

  isBeheerder(): boolean {
    return this.groups.includes(UserGroup.BEHEERDER);
  }

  isMonitor(): boolean {
    return this.groups.includes(UserGroup.MONITOR);
  }

  isKind(): boolean {
    return this.groups.includes(UserGroup.KIND);
  }

  hasOneOfGroups(requiredGroups: readonly UserGroup[]): boolean {
    return requiredGroups.some((requiredGroup) => this.groups.includes(requiredGroup));
  }

  getFirstGroup(): UserGroup {
    return this.groups[0];
  }

  hasGroup(): boolean {
    return this.groups.length > 0;
  }

  isVolunteerTablet(): boolean {
    return this.groups.includes(UserGroup.VOLUNTEERTABLET);
  }
}

export enum UserGroup {
  ADMIN = 'Admin',
  BEHEERDER = 'Beheerder',
  MONITOR = 'Monitor',
  KIND = 'Kind',
  VOLUNTEERTABLET = 'VolunteerTablet',
}

export type JwtPayload = {
  sub: string;
  email: string;
  email_verified: boolean;
  'cognito:groups': string[];
};
